import * as React from "react";
import { Grid, Button } from "@mui/material";
import { useNavigate } from "react-router-dom"; // <-- import useNavigate
import MainTheme from "../mainTemplate";
import Title from "../../utilities/title";
import Label from "../../utilities/label";
import Input from "../../utilities/input";

const GenesysCloudCredentials = () => {
  const navigate = useNavigate(); // <-- initialize navigate

  const handleQueueMetricsClick = () => {
    navigate("/Queue-Metrics"); // <-- navigate to /Queue-Metrics
  };
  const handleAgentMetricsClick = () => {
    navigate("/Agent-Metrics"); // <-- navigate to /add-queues
  };
     const handleSentimentAnalysisMetricsClick = () => {
    navigate("/Sentiment-Analysis-Metrics"); // <-- navigate to /add-queues
  };
    const handleCallRecordingMetricsClick = () => {
    navigate("/CallRecording-Metrics"); // <-- navigate to /add-queues
  };
  

  return (
    <MainTheme>
      <Title title="Metrics" />

      <div className="organization-details-section">
        <Grid container spacing={2} className="conatiner-section">
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleQueueMetricsClick} // <-- assign handler
            >
              Queue Metrics
            </Button>
          
           
          </Grid>
          <Grid item xs={12}>
           <Button
              variant="contained"
              color="primary"
              onClick={handleAgentMetricsClick} // <-- assign handler
            >
              Agent Metrics
            </Button>
            </Grid>


             <Grid item xs={12}>
           <Button
              variant="contained"
              color="primary"
              onClick={handleSentimentAnalysisMetricsClick} // <-- assign handler
            >
              Sentiment Analysis Metrics
            </Button>
            </Grid>


            <Grid item xs={12}>
           <Button
              variant="contained"
              color="primary"
              onClick={handleCallRecordingMetricsClick} // <-- assign handler
            >
              Call Recording Metrics
            </Button>
            </Grid>
        </Grid>
      </div>
    </MainTheme>
  );
};

export default GenesysCloudCredentials;
